// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__x7xZA","tab":"Tabs_tab__it1iZ","active":"Tabs_active__HoT7i","badge":"Tabs_badge__lYbme"};